package com.ervasstudio.tracoemovimento.model

enum class EtapasDeCadastro {
    PrimeitaEtapa,
    SegundaEtapa,
}